import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import './AuthForms.css';

function EmailVerificationRequired() {
  const { currentUser, sendVerificationEmail, logout } = useAuth();
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleResendEmail = async () => {
    setSending(true);
    setMessage('');
    setError('');

    try {
      await sendVerificationEmail();
      setMessage('Verification email sent! Please check your inbox and spam folder.');
    } catch (err: any) {
      console.error('Error sending verification email:', err);
      if (err.message === 'Email already verified') {
        setMessage('Your email is already verified! Refreshing...');
        setTimeout(() => window.location.reload(), 2000);
      } else {
        setError('Failed to send email. Please try again in a few minutes.');
      }
    } finally {
      setSending(false);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (err) {
      console.error('Logout error:', err);
    }
  };

  return (
    <div className="verification-container">
      <div className="verification-card">
        <div className="verification-icon">📧</div>
        <h2>Verify Your Email</h2>
        <p className="verification-message">
          We've sent a verification email to <strong>{currentUser?.email}</strong>
        </p>
        <p className="verification-instructions">
          Please check your inbox and click the verification link to activate your account.
        </p>

        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}

        <div className="verification-actions">
          <button
            onClick={handleResendEmail}
            disabled={sending}
            className="btn-primary"
          >
            {sending ? 'Sending...' : 'Resend Verification Email'}
          </button>
          
          <button
            onClick={() => window.location.reload()}
            className="btn-secondary"
          >
            I've Verified - Refresh
          </button>

          <button
            onClick={handleLogout}
            className="btn-text"
          >
            Sign Out
          </button>
        </div>

        <div className="verification-help">
          <p><strong>Didn't receive the email?</strong></p>
          <ul>
            <li>Check your spam/junk folder</li>
            <li>Make sure you entered the correct email</li>
            <li>Wait a few minutes and try resending</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default EmailVerificationRequired;
